import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredRole: string | string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { loading, user } = useSelector((state: RootState) => state.session);
  const { isImpersonating, adminUser } = useSelector((state: RootState) => state.impersonation);

  // Wait for auth state to resolve before making routing decisions
  if (loading) {
    return <div style={{ minHeight: '100vh' }} />; // Prevent unmount, keep layout stable
  }

  const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

  // When impersonating, the admin can access any route
  if (isImpersonating && adminUser?.role === "ADMIN") {
    return children;
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
